import { Component } from "@angular/core";
import { Platform } from "ionic-angular";
import { StatusBar } from "@ionic-native/status-bar";
import { SplashScreen } from "@ionic-native/splash-screen";

import { User } from "../services/user";
import { env } from "../config/environment";
import { Api } from "../services/api";
import { AlertIfDebugging, IsDebuggingMode } from "../services/util";

const backendUrlsByHost = {
  "kanjia.tuozhanpian.com": "https://kanjia-server.tuozhanpian.com/",
  "kanjia-2.tuozhanpian.com": "https://kanjia-server-2.tuozhanpian.com/",
};

const backendUrl = backendUrlsByHost[window.location.hostname];
if (backendUrl) {
  env.prod = true;
  env.server_url = backendUrl;
}

if (window.location.href.indexOf("?s=wx") < 0) {
  window.location.assign(
    window.location.origin + "/?s=wx" + window.location.hash
  );
}

@Component({
  templateUrl: "app.html",
})
export class MyApp {
  rootPage: any = null;

  constructor(
    platform: Platform,
    statusBar: StatusBar,
    splashScreen: SplashScreen,
    user: User,
    private api: Api
  ) {
    this.initWeixin();
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();
      splashScreen.hide();
    });
  }

  initWeixin() {
    window["wx_init_promise"] = new Promise((resolve, reject) => {
      this.api.weixinSignParams().then((data) => {
        AlertIfDebugging(`weixinSignParams return ${JSON.stringify(data)}`);
        let wxConfig = {
          debug: IsDebuggingMode(),
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"],
        };
        AlertIfDebugging(JSON.stringify(wxConfig));
        window["wx"].config(wxConfig);
        window["wx"].ready(function () {
          AlertIfDebugging("wx ready");
          resolve();
        });
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts